<select [ngClass]="selectedItem == undefined ? 'default-color' : ''" [ngModel]="selectedItem" (ngModelChange)="onChange($event)">
  <option [value]="undefined" disabled>{{defaultText}}</option>
  <option class="normal-color" *ngFor="let ea of items" [value]="ea.id">{{ ea.field }}</option>
</select>
